var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.circle)?_c('div',{staticClass:"wrapper-circle"},[_c('v-progress-circular',{attrs:{"indeterminate":"","width":10,"size":70}})],1):_c('div',{staticClass:"wrapper-loader"},[_vm._v("Загрузка")])
}
var staticRenderFns = []

export { render, staticRenderFns }